import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { forEach } from 'lodash';
import {
    ColumnType,
} from '../../../shared/components/table-settings/table-settings.component';

// Services
import { SharedService } from '../../../layouts/shared-service';
import { AntennaStatusGridViewmodel } from 'src/app/models/antenna-status/antenna-status-grid-viewmodel';

import { DeleteConfirmationComponent, DeleteConfirmationData } from 'src/app/shared/components/delete-confirmation/delete-confirmation.component';
import { AppDialogWrapperService } from '../../../ni-components/app-dialog-wrapper/app-dialog-wrapper.service';
import * as XLSX from 'xlsx-js-style';

const NOT_ACTIVE_STATUS = 'Not Active';
const ACTIVE_STATUS = 'Active';
const initialColumns: ColumnType[] = [
    {
        id: 'boxName',
        name: 'Antenna Name',
    },
    {
        id: 'status',
        name: 'Status'
    },
    {
        id: 'lastUpdateRaw',
        name: 'Last Update Raw',
    },
    {
        id: 'lastUpdateCurated',
        name: 'Last Update Curated',
    },
    {
        id: 'fbolinxAccount',
        name: 'FBOlinx Account',
    },
    {
        id: 'delete',
        name: 'delete',
    }
];

@Component({
    selector: 'app-antenna-status-grid',
    styleUrls: ['./antenna-status-grid.component.scss'],
    templateUrl: './antenna-status-grid.component.html',
})
export class AntennaStatusGridComponent implements OnInit {
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @Input() antennaStatusGridData: AntennaStatusGridViewmodel[];
    @Output() deleteAntennaCallback = new EventEmitter<any>();

    tableLocalStorageKey = 'antenna-status-table-settings';

    antennaStatusDataSource: MatTableDataSource<AntennaStatusGridViewmodel> = null;
    columns: ColumnType[] = [];

    constructor(
        private appDialogWrapperService: AppDialogWrapperService,
    ) {

    }

    ngOnInit() {
        if (localStorage.getItem(this.tableLocalStorageKey)) {
            this.columns = JSON.parse(
                localStorage.getItem(this.tableLocalStorageKey)
            );
        } else {
            this.columns = initialColumns;
        }

        this.refreshAntennaStatusDataSource();
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.antennaStatusGridData) {
            this.refreshAntennaStatusDataSource();
        }
    }   

    getTableColumns() {
        return this.columns
            .filter((column) => !column.hidden)
            .map((column) => column.id);
    }
    deleteAntenna(antenna: any) {
        const dialogWrapper = this.appDialogWrapperService.open<DeleteConfirmationData>({
            title: 'Delete Antenna',
            component: DeleteConfirmationComponent,
            data: { description: 'Antenna', item: antenna, includeThis: false } as DeleteConfirmationData,
            width: '450px',
            hideHeader: true
        });

        dialogWrapper.afterClosed().subscribe((result: DeleteConfirmationData) => {
            if (!result) {
                return;
            }
            this.deleteAntennaCallback.emit(antenna);
        });
    }

    private refreshAntennaStatusDataSource() {
        if (!this.antennaStatusDataSource) {
            this.antennaStatusDataSource = new MatTableDataSource<AntennaStatusGridViewmodel>();
        }

        this.antennaStatusDataSource.data = this.antennaStatusGridData;
        this.antennaStatusDataSource.sort = this.sort;
    }

    isAntennaHighlighted(antenna: AntennaStatusGridViewmodel): boolean {
        return antenna.fbolinxAccount?.trim()?.length > 0  &&
               antenna.hasBeenOnline && antenna.status == NOT_ACTIVE_STATUS;
    }

    exportCsv() {
        const exportColumns = this.columns.filter(col => col.id !== 'delete' && !col.hidden);

        const exportData = this.antennaStatusDataSource.filteredData.map(item => {
            const row = {};
            exportColumns.forEach(col => {
                row[col.name] = item[col.id];
            });
            return row;
        });

        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);

        const headerStyle: XLSX.CellStyle = {
            font: { bold: true },
            alignment: { horizontal: 'center', wrapText: true, vertical: 'center' },
        };

        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let colIndex = range.s.c; colIndex <= range.e.c; colIndex++) {
            const cellAddress = { c: colIndex, r: range.s.r };
            if (ws[XLSX.utils.encode_cell(cellAddress)]) {
                ws[XLSX.utils.encode_cell(cellAddress)].s = headerStyle;
            }
        }

        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Antenna Status');
        XLSX.writeFile(wb, 'Antenna Status.xlsx');
    }
}
